module.exports = __webpack_public_path__ + "static/media/11.43dea1c4.JPG";